export default __webpack_public_path__ + "static/media/bolinhas3.ca69f4ed.svg";